import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-confirm-cancel',
  templateUrl: './confirm-cancel.component.html'
})
export class ConfirmCancelComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ConfirmCancelComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // them chuc nang close message băng Esc vaf click chuot
    dialogRef.disableClose = true;
  }

  ngOnInit() {
  }

  onNoClick() {
    this.dialogRef.close();
  }

}
